/**
 * Shared WOM videos API fetch.
 * One in-flight / cached JSON response per product/company endpoint so
 * story rings, card gallery, and the draggable PiP do not each hit the
 * network for the same ?product_id=… payload.
 */
(function () {
  'use strict';

  if (window.WOMVideoFeed) return;

  var cache = {};
  function cacheKey(url) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.delete('_ts');
      u.searchParams.delete('t');
      u.hash = '';
      return u.toString();
    } catch (e) {
      return String(url)
        .replace(/([?&])_ts=\d+/g, '$1')
        .replace(/([?&])t=\d+/g, '$1')
        .replace(/[?&]$/, '');
    }
  }

  function get(apiUrl) {
    if (!apiUrl) return Promise.resolve(null);

    var key = cacheKey(apiUrl);
    if (cache[key]) {
      return cache[key];
    }

    // Prefer head-started homepage fetches when the key matches.
    var PRIORITY = window.WOMPriority;
    if (PRIORITY && PRIORITY.takeEarlyFetch) {
      var early = null;
      if (key.indexOf('category=stories') !== -1) {
        early = PRIORITY.takeEarlyFetch('videos:stories');
      } else if (key.indexOf('product_id=') === -1) {
        early = PRIORITY.takeEarlyFetch('videos:gallery');
      }
      if (early) {
        cache[key] = early.catch(function (err) {
          delete cache[key];
          throw err;
        });
        return cache[key];
      }
    }
    cache[key] = fetch(apiUrl, {
      headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' },
      cache: 'no-store'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Videos API failed: ' + r.status);
        return r.json();
      })
      .catch(function (err) {
        delete cache[key];
        throw err;
      });

    return cache[key];
  }

  /** Seed cache with an existing promise (e.g. earlyFetch from boot priority). */
  function put(apiUrl, promise) {
    if (!apiUrl || !promise) return;
    var key = cacheKey(apiUrl);
    if (cache[key]) return cache[key];
    cache[key] = Promise.resolve(promise).catch(function (err) {
      delete cache[key];
      throw err;
    });
    return cache[key];
  }

  window.WOMVideoFeed = {
    get: get,
    put: put,
    cacheKey: cacheKey
  };
})();
